export default {
    loggedInState: false,
    empPopUpShown: 0,
    userInfo: {
        token: '',
        role: '',
        username: '',
        email: '',
        companyID: '',
        userID: '',
        uid: '',
        namespace: '',
        email_verified: false
    },
    countries: [],
    authHeader: {
        headers: { 'id-token': '' },
    },
    company: {},
    companyInfo: {
        name: '',
        location: '',
        //membership: '',
        status: '',
        //orgNr: '',
        logoUrl: '',
        companyId: '',
    },
    companyTimeline: [],
    locations: [],
    location: {},
    departments: [],
    // dashboard_old: {
    //     calendar: false,
    //     timeline: new Map(),
    //     todos: [],
    //     announcements: [],
    //     me: {
    //         id: '',
    //         lastName: '',
    //         firstName: '',
    //         status: '',
    //     },
    // },
    dashboard: {
        me: {},
        company: {},
        calendar: false,
        activities: {
            anniversary: null,
            everything: null,
            holidays: null,
            time_off: null,
        },
        announcements: [],
        todos: [],
        benefits: [],
        my_time_offs: [],
        available_timeoffs: [],
    },
    availableTimeoffs: [], //aggregate of my available leave types
    myTimeoffs: [], // list of approved timeoffs
    everything: [], // everything on the dashboard timeline
    announcements: [],
    calendar: {
        info: {
            status: false,
            list: [],
        },
        today: new Date().toISOString().substring(0, 10),
        events: [],
    },
    // Workflows
    workflows: [],
    backofficeItems: [],
    leaveTypes: [],
    adminLeavePolicies: [],

    // marketplace offers
    marketplaceOffers: [],

    // benefits
    benefits: [],
    benefitList: [],
    timeOffs: [],
    employeeTimeline: [],
    provider: {},
    providerBenefits: {},
    marketplaceSearch: {},
    me: {},
    accessRequests: []
};